export const POPOVER_NOTIFICATIONS_DRAWER_CSS_CLASS = 'popover-notifications-drawer';
export const GENERIC_MESSAGE_PLACEHOLDER = '__GENERIC_MESSAGE__';
export const URL_PATTERN =
    /(https?:\/\/|www\.)[^\s]+|(?=.*[a-zA-Z])[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.([a-zA-Z]{2,})/i;
